<template>
  <div class="doctor-card">
    <loading-messages v-if="loading"></loading-messages>
    <template v-else-if="doctor">
      <div class="row no-gutters align-items-center p-3">
        <div class="col-auto mr-2">
          <div
            class="avatar"
            :style="{
              backgroundImage: `url(${staticUrl}${doctor.photo})`,
            }"
          ></div>
        </div>
        <div class="col">
          <h4>
            {{ doctor.firstname[authLocale] }}
            {{ doctor.lastname[authLocale] }}
          </h4>
          <ul class="list-group list-group-horizontal">
            <li
              class="p-2 list-group-item list-group-item-light"
              v-if="doctor.title && doctor.title[authLocale]"
            >
              <small>
                <strong>
                  {{ doctor.title[authLocale] }}
                </strong>
              </small>
            </li>
            <li
              class="p-2 list-group-item list-group-item-light"
              v-if="
                doctor.speciality_id && specialityById(doctor.speciality_id)
              "
            >
              <small>
                <strong>
                  {{
                    specialityById(doctor.speciality_id).doctor_name[authLocale]
                  }}
                </strong>
              </small>
            </li>
            <li
              class="p-2 list-group-item list-group-item-light"
              v-if="doctor.experience_from"
            >
              <small>
                <strong>
                  {{ $moment().format("YYYY") - doctor.experience_from }}
                  {{ $t("experience") }}
                </strong>
              </small>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import LoadingMessages from "@/components/Loadings/Message";
export default {
  components: {
    LoadingMessages,
  },
  props: {
    doctorId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      doctor: null,
    };
  },
  computed: {
    ...mapGetters({
      authLocale: "auth/locale",
      staticUrl: "app/staticUrl",
      specialityById: "speciality/byId",
    }),
  },
  watch: {
    patientId: {
      handler(val) {
        this.fetch();
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations({
      setError: "alert/setError",
    }),
    async fetch() {
      this.loading = true;
      try {
        const response = await this.axios.get(`/api/doctors/${this.doctorId}`);
        this.doctor = response.data.data;
        this.loading = false;
      } catch (err) {
        this.setError(err);
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss">
.doctor-card {
  .avatar {
    width: 75px;
    height: 75px;
  }
  ul {
    list-style: bullet;
    font-size: 0.9em;
  }
}
</style>
<i18n>
{
  "ka": {
    "experience": "წლის გამოცდილება"
  },
  "en": {
    "experience": "Years of experience"
  }
}
</i18n>
